export default "__VITE_ASSET__EQ$KLyU$__"